import type { Sticker } from '../types';

export const internet: Sticker[] = [
  {
    id: 17001,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/001-mail.png',
    name: 'Email',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17002,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/002-satellite.png',
    name: 'Satelita',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17003,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/003-mail.png',
    name: 'Wiadomość',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17004,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/004-bell.png',
    name: 'Powiadomienie',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17005,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/005-ecommerce.png',
    name: 'Sklep Online',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17006,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/006-not found.png',
    name: 'Nie Znaleziono',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17007,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/007-wifi.png',
    name: 'WiFi',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17008,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/008-internet.png',
    name: 'Internet',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17009,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/009-internet.png',
    name: 'Sieć',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17010,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/010-adjustment.png',
    name: 'Ustawienia',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17011,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/011-message.png',
    name: 'Komunikator',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17012,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/012-settings.png',
    name: 'Konfiguracja',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17013,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/013-modem.png',
    name: 'Modem',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17014,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/014-internet.png',
    name: 'Połączenie',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17015,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/015-cloud.png',
    name: 'Chmura',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17016,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/016-internet.png',
    name: 'Przeglądarka',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17017,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/017-internet.png',
    name: 'Strona WWW',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17018,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/018-html.png',
    name: 'Kod HTML',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17019,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/019-folder.png',
    name: 'Folder',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 17020,
    url: 'https://stickers.nauczniaczek.pl/colections/13725474-internet/png/020-protection.png',
    name: 'Bezpieczeństwo',
    category: 'internet',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];